import { createContext } from 'react';

export const darkModeActionContext = createContext();
export const darkModeContext = createContext();
